import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  submitButtonText: {
    id: 'portal.views.registration.submit.button.text',
    defaultMessage: 'Continue',
    description: 'Text for submit button',
  },
  submitLoadingButtonText: {
    id: 'portal.views.registration.submit.loading.button.text',
    defaultMessage: 'Submitting',
    description: 'Text for submit loading button',
  },
  tosLinkText: {
    id: 'portal.views.registration.tos.link.text',
    defaultMessage: 'Terms of Use',
    description: 'Text for terms of use link',
  },
  privacyLinkText: {
    id: 'portal.views.registration.privacy.link.text',
    defaultMessage: 'Privacy Policy',
    description: 'Text for privacy policy link',
  },
});

export default messages;
